<template>
  <div class="main-simule-aqui">
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="simule-aqui" class="adesao-finalizada">
            <div
              style="
                display: block;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 57px;
              "
            >
              <h3>Adesão Realizada</h3>
              <br />
            </div>
            <div style="display: block; margin-top: 38px">
              <img src="../assets/finalizado.svg" alt="Adesão Realizada" />
            </div>
            <div
              style="
                display: block;
                width: 512px;
                margin: 0 auto;
                margin-top: 34px !important;
              "
            >
              <p class="text-adesao-finalizada">
                Agora que recebemos todos os seus documentos, a nossa equipe irá analisá-los. Você pode acompanhar o status da sua proposta pela <a href="https://svc.aliancaadm.com.br/aplicacoes/servicosonline/" target="_blank">área do cliente</a>, pelo email ou pelos nossos canais de ajuda.
              </p>
            </div>
            <div style="display: block; margin-top: 20px">
              <a
                href="https://aliancaadm.com.br/"
                class="link-adesao-finalizada link-nofocus"
                >Voltar para página inicial</a
              >
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "Proposta-finalizada",
  mixins: [],
  components: {},
  data() {
    return {
      cep: "",
    };
  },
  methods: {},
  created() {
    //this.recoveryStep()
  },
};
</script>
<style lang="scss">
.main-simule-aqui {
  min-height: 100vh;
}
</style>
